import { AiTasks } from '@/components';

const AiTasksRoute = () => <AiTasks />;

export default AiTasksRoute;
